import AbstractCollision from './abstractCollision';

/**
 * Intersection collision. At least one line of the item crosses a line of the other item.
 *
 * @class IntersectionCollision
 * @extends AbstractCollision
 */
export default class IntersectionCollision extends AbstractCollision {
    /**
     * @constructor
     * @param {AbstractItem} item
     * @param {AbstractItem} otherItem
     * @param {Intersections} intersections
     */
    constructor(item, otherItem, intersections) {
        super(item, otherItem);
        this.intersections = intersections;
    }
}
